import React from "react";
import "./Services.css";
import user_experience from "../../Assets/Icons/rating.png";
import responsive_Design from "../../Assets/Icons/responsive-design.png";
import maintaining from "../../Assets/Icons/touch-screen.png";
import SEO from "../../Assets/Icons/search-engine-optimization.png";

const servicesData = [
  {
    title: "Optimizing the user experience",
    img: user_experience,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur iste molestiae illum aspernatur rerum laudantium, eum voluptatem dolores quo exercitationem ea quis, similique iusto animi sit molestias ducimus velit. Ducimus.",
  },
  {
    title: "Fully Responsive Design",
    img: responsive_Design,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur iste molestiae illum aspernatur rerum laudantium, eum voluptatem dolores quo exercitationem ea quis, similique iusto animi sit molestias ducimus velit. Ducimus.",
  },
  {
    title: "Developing and maintaining the UI",
    img: maintaining,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur iste molestiae illum aspernatur rerum laudantium, eum voluptatem dolores quo exercitationem ea quis, similique iusto animi sit molestias ducimus velit. Ducimus.",
  },
  {
    title: "Following SEO best practices",
    img: SEO,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur iste molestiae illum aspernatur rerum laudantium, eum voluptatem dolores quo exercitationem ea quis, similique iusto animi sit molestias ducimus velit. Ducimus.",
  },
];

function Services() {
  return (
    <section className="services" id="services">
      <div className="container">
        <h3>Services</h3>
        <div className="box-card">
          {servicesData.map((card) => (
            <div className="card" key={card.title}>
              <span className="icon">
                <img src={card.img} alt="" />
              </span>
              <p>{card.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
